import {
  AppFreeAnswerRecordingCancelled,
  AppFreeAnswerRecordingError,
  AppFreeAnswerRecordingReady,
  AppFreeAnswerRecordingUploaded,
} from 'altru-types/@types/app-free-events';

const sendRecordingReadyMessage = (payload: AppFreeAnswerRecordingReady, origin = '*'): void => {
  window.parent.postMessage(payload, origin);
};

const sendRecordingCancelledMessage = (payload: AppFreeAnswerRecordingCancelled, origin = '*'): void => {
  window.parent.postMessage(payload, origin);
};

const sendRecordingUploadedMessage = (payload: AppFreeAnswerRecordingUploaded, origin = '*'): void => {
  window.parent.postMessage(payload, origin);
};

const sendRecordingErrorMessage = (payload: AppFreeAnswerRecordingError, origin = '*'): void => {
  window.parent.postMessage(payload, origin);
};

export {
  sendRecordingReadyMessage,
  sendRecordingCancelledMessage,
  sendRecordingUploadedMessage,
  sendRecordingErrorMessage,
};
